module.exports = __webpack_public_path__ + "static/media/th-TH.5de2055f.md";